export default __webpack_public_path__ + "assets/icon-point-of-sale.fbd697bb.webp";